// Canonical public origin baked in at build time (see REACT_APP_DEPLOY_ORIGIN in CI).
// Must match backend/config/deploy.js default and backend/.env DEPLOY_ORIGIN.
export const DEPLOY_ORIGIN =
  process.env.REACT_APP_DEPLOY_ORIGIN || 'https://jao7pfi9yg.com'
